(function () {
  if (window.kaboomCollectionNavLoadingInitialised) return;
  window.kaboomCollectionNavLoadingInitialised = true;

  document.addEventListener(
    "click",
    function (event) {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest("a[href]");
      if (!link) return;

      const destination = new URL(link.href, window.location.href);

      if (destination.origin !== window.location.origin) return;
      if (!destination.pathname.startsWith("/collections/")) return;
      if (destination.href === window.location.href) return;

      link.classList.add("is-loading");
      link.setAttribute("aria-busy", "true");
      document.documentElement.classList.add("collection-is-navigating");
    },
    true
  );

  window.addEventListener("pageshow", function () {
    document.documentElement.classList.remove(
      "collection-is-navigating"
    );

    document
      .querySelectorAll('a[aria-busy="true"]')
      .forEach(function (link) {
        link.classList.remove("is-loading");
        link.removeAttribute("aria-busy");
      });
  });
})();